
// import Logo from '../images/FidelitusTransaction.png'
import Logo from '../../folder/images/FidelitusLogo.png'

import {IoMdCall} from 'react-icons/io'

import {BiLogoFacebook,BiLogoLinkedin} from 'react-icons/bi'
import {AiFillInstagram,AiFillYoutube,AiOutlineMail} from 'react-icons/ai'
import {IoLogoWhatsapp} from 'react-icons/io'
import {IoLocationOutline} from 'react-icons/io5'

import { address, email, mobile } from '../constants/Appconstants'
import { useLocation, useNavigate } from 'react-router-dom'


export default function Footer() {


  const { pathname } = useLocation()
  const navigator = useNavigate()


  const social_media = [
    {'icon':BiLogoFacebook,name:'Facebook',id:1,path:'https://www.facebook.com/Fidelitus/'},
    {'icon':AiFillInstagram,name:'Instagram',id:2,path:'https://www.instagram.com/fidelitus.corp/'},
    {'icon':BiLogoLinkedin,name:'LinkedIn',id:3,path:'https://in.linkedin.com/company/fidelituscorp-property-services-private-ltd'},
    {'icon':AiFillYoutube,name:'YouTube',id:4,path:'https://youtu.be/y-3CAl8M9yA'},
    {'icon':IoLogoWhatsapp,name:'WhatsApp',id:5,path:'https://api.whatsapp.com/send?phone=919845062227&text=Hi%20I%20would%20like%20to%20connect%20with%20you'},
  ]

  const menu = [
    {name:'About Us ',path:'/about/our_vision',id:2},
    {name:'Why Us',path:'/why-us',id:7},
    {name:'Our Blog',path:'/blogs',id:5},
    {name:'Careers',path:'/join_us',id:6},
    {name:'Contact Us',path:'/contact',id:4},
  ]




  const other_services = [
    {name:"Real Estate Transactions",path:'/real-estate'},
    {name:"Projects",path:'/projects'},
    {name:"Facility Managment Services",path:'/facility-management-services'},
    {name:"HR Labs",path:'/hr-labs'},
  ]
  
  return (
    <>
    <div className="min-w-screen border-t py-10  border-slate-100 w-full text-[#000]">
       <div className='w-[90vw] md:w-[85vw]  mx-auto   md:grid-cols-5'>


       <div className='md:flex'>
        <div className='md:min-w-[30%] md:max-w-[30%] col-span-2 md:px-4 md:border-r border-gray-200'>
        <img src={Logo} alt="FidelitusHrLab" className='w-[120px] bg-white py-[2px] object-stretch cursor-pointer' />

        <h6 className='text-[14px] 2xl:text-[17px] font_normal mt-2'>Fidelitus Corp</h6>


        <div>
           <div className='flex md:ml-1 mt-2'>
            <IoLocationOutline color='#4190ac' size={50} />
            <h6 className='text-[12px] 2xl:text-[15px] font_normal cursor-pointer pl-3'>{address}</h6>
           </div>

           <div className='flex md:ml-1 mt-2'>
           <IoMdCall color='#4190ac' size={15} />
            <h6 className='text-[12px] 2xl:text-[15px] font_normal cursor-pointer  pl-2'>{mobile}</h6>
            </div>

            <div className='flex md:ml-1 mt-2.5'>
           <AiOutlineMail color='#4190ac' size={15}/>
            <h6 className='ml-1 text-[12px] 2xl:text-[15px] font_normal cursor-pointer  pl-2'>{email}</h6>
            </div>
        </div>

        </div>

        <div className='grid md:px-4 md:px-0 pt-5 md:pt-0 md:min-w-[65%] md:max-w-[65%] grid-flow-row-dense md:grid-cols-3'>
        <div className='md:border-r mt-4 md:mt-0  md:px-4  border-gray-200'> 
            <h6 className=' text-[14px] 2xl:text-[17px] font_bold uppercase text-black font-[600] mb-2'>Quick Links</h6>
                {menu?.map((m)=>(
                  <h6 onClick={()=>navigator(m?.path)} key={m?.path} className='text-[12.5px] 2xl:text-[15.5px] font_normal py-1 text-black opacity-70 hover:opacity-100  cursor-pointer'>{m?.name}</h6>
                ))}
        </div>

        <div className='md:border-r mt-4 md:mt-0  md:px-4 border-gray-200'> 
            <h6 className='font_bold uppercase text-[14px] text-black font-[600] mb-2'>Services</h6>
           {other_services?.map((s,i)=>(
            <h6 key={i} onClick={()=>navigator(s?.path)} className='text-[12.5px] 2xl:text-[15.5px] font_normal py-1 text-black opacity-70 hover:opacity-100 cursor-pointer'> {s?.name}</h6>
           ))}  
        </div>
        <div className='mt-4 md:mt-0  md:px-4   border-gray-200'> 
            <h6 className=' text-[14px] 2xl:text-[17px] font_bold uppercase text-black font-[600]'>More Links</h6>
            <h6 className='text-[13px] 2xl:text-[16px] font_normal font-[300] text-black my-2 leading-tight'>If you are found of art please visit our gallery..</h6>

           <a href={'https://fidelitusgallery.com/'} target='_blank'>
            <h6 className='text-[13px] 2xl:text-[16px] font_normal  font-[600] py-1 text-black opacity-70 cursor-pointer hover:opacity-100'>{'Fidelitus Gallery'}</h6>
            </a>
            <h6 className='text-[13px] 2xl:text-[16px] font_normal   border-t pt-2 text-black my-2 leading-tight'>Support Shilpa Foundation to brighten in the future! Every rupee contributes to education and environment.</h6>
            
            <a href={'https://shilpafoundation.org/'} target='_blank'>
            <h6 className='text-[13px] 2xl:text-[16px] font_normal font-[600] py-1 opacity-70  cursor-pointer hover:opacity-100'>{'Shilpa Foundation'}</h6>
            </a>
        </div>
        </div>
       </div>
        </div>
    </div>
    <p className='text-[9px] 2xl:text-[12px]  font_normal bg-gray-900 text-black text-center w-full py-2 text-slate-400'>© 2025 Fidelitus Corp Property Services Pvt Ltd. All Rights Reserved</p>
    </>
  )
}
